/*eslint-disable */
import request from '../../Utils/curl'
import Utility from "../../Utils/utility";

let moduleApiObj = {
  /**
   * moduleList
   */
  async moduleList (context, moduleObj={}) {
    try{
      let post_data = new FormData();
        
      for (let key in moduleObj) {
        post_data.append(key, moduleObj[key]);
      }

      return await request.curl(context, "module_list", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.error('Exception occurred at moduleList() and Exception:',err.message)
    }
  }
}

export {
  moduleApiObj
}
